import { useMemo } from "react";

import { Modal as SharedModal } from "@sorcery/ui";

import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";
import { AdvancedCardSearchModal } from "../modals/AdvancedCardSearchModal";
import { AdvancedDeckSearchModal } from "../modals/AdvancedDeckSearchModal";
import { CardGallery } from "../modals/CardGallery";
import { CollectionAddGallery } from "../modals/CollectionAddGallery";
import { CollectionBulkAddModal } from "../modals/CollectionBulkAddModal";
import { CollectionDeleteCardsModal } from "../modals/CollectionDeleteCardsModal";
import { CollectionDeleteModal } from "../modals/CollectionDeleteModal";
import { CollectionEditGallery } from "../modals/CollectionEditGallery";
import { DeckCopyModal } from "../modals/DeckCopyModal";
import { DeckCreateModal } from "../modals/DeckCreateModal";
import { DeckDeleteModal } from "../modals/DeckDeleteModal";
import { DeckExportModal } from "../modals/DeckExportModal";
import { DeckGallery } from "../modals/DeckGallery";
import { FolderCreateModal } from "../modals/FolderCreateModal";
import { FolderDeleteModal } from "../modals/FolderDeleteModal";
import { FolderRenameModal } from "../modals/FolderRenameModal";
import { MoveDeckToFolderModal } from "../modals/MoveDeckToFolderModal";
import { PrintoutCollectionTrackersModal } from "../modals/PrintoutCollectionTrackersModal";
import { SearchModal } from "../modals/SearchModal";

export const ModalDecorator = () => {
  const { closeModal, isModalOpen, modalType, props } = useModal();
  const modalResolver = () => {
    switch (modalType) {
      case ModalTypeEnum.SEARCH:
        return <SearchModal />;
      case ModalTypeEnum.CREATEDECK:
        return <DeckCreateModal />;
      case ModalTypeEnum.COPYDECK:
        return <DeckCopyModal />;
      case ModalTypeEnum.CREATEFOLDER:
        return <FolderCreateModal />;
      case ModalTypeEnum.CREATECOLLECTIONITEMGALLERY:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <CollectionAddGallery card={props!.card!} variant={props!.variant!} />;
      case ModalTypeEnum.EDITCOLLECTIONITEMGALLERY:
        return (
          <CollectionEditGallery
            // biome-ignore lint/style/noNonNullAssertion: <explanation>
            item={props!.item!}
            // biome-ignore lint/style/noNonNullAssertion: <explanation>
            card={props!.card!}
            // biome-ignore lint/style/noNonNullAssertion: <explanation>
            variant={props!.variant!}
          />
        );
      case ModalTypeEnum.DECKGALLERY:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <DeckGallery card={props!.card!} />;
      case ModalTypeEnum.CARDGALLERY:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <CardGallery card={props!.card!} />;
      case ModalTypeEnum.EXPORTDECK:
        return <DeckExportModal />;
      case ModalTypeEnum.DELETEDECK:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <DeckDeleteModal deckId={props!.deckId!} />;
      case ModalTypeEnum.DELETECOLLECTION:
        return <CollectionDeleteModal />;
      case ModalTypeEnum.DELETECOLLECTIONCARDS:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <CollectionDeleteCardsModal card={props!.card!} variant={props!.variant} />;
      case ModalTypeEnum.BULKADDTOCOLLECTION:
        return <CollectionBulkAddModal />;
      case ModalTypeEnum.ADVANCEDCARDSEARCH:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <AdvancedCardSearchModal filters={props!.filters!} onConfirm={props!.onConfirm!} />;
      case ModalTypeEnum.ADVANCEDDECKSEARCH:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <AdvancedDeckSearchModal filters={props!.filters!} onConfirm={props!.onConfirm!} />;
      case ModalTypeEnum.PRINTOUTCOLLECTIONTRACKERS:
        return <PrintoutCollectionTrackersModal />;
      case ModalTypeEnum.FOLDERDELETE:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <FolderDeleteModal folderId={props!.folderId!} />;
      case ModalTypeEnum.MOVEDECKTOFOLDER:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <MoveDeckToFolderModal deckId={props!.deckId!} deckName={props!.deckName!} />;
      case ModalTypeEnum.RENAMEFOLDER:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <FolderRenameModal folderId={props!.folderId!} />;
    }
  };

  const isGallery = useMemo(
    () =>
      modalType === ModalTypeEnum.CARDGALLERY ||
      modalType === ModalTypeEnum.DECKGALLERY ||
      modalType === ModalTypeEnum.CREATECOLLECTIONITEMGALLERY ||
      modalType === ModalTypeEnum.EDITCOLLECTIONITEMGALLERY,
    [modalType],
  );

  return (
    <SharedModal
      renderContent={modalResolver}
      closeModal={closeModal}
      isModalOpen={isModalOpen}
      isGallery={isGallery}
    />
  );
};
